import { IconSitemap, IconPlus, IconHierarchyOff } from "@tabler/icons-react";
import TeamCard from "./TeamCard";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";
import Button from "../UI/Button/button";

export default function TeamManagementCard({
  teams,
  users,
  loading,
  canWrite,
  onAddTeam,
  onEditTeam,
  onDeleteTeam,
}) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={`${styles.cardIcon} ${styles.amberIcon}`}>
            <IconSitemap size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Team Management</div>
            <div className={styles.cardSubtitle}>
              Group users into functional teams
            </div>
          </div>
        </div>
        {canWrite && (
          <Button
            variant="primary"
            leftIcon={<IconPlus size={16} />}
            onClick={onAddTeam}
          >
            Add Team
          </Button>
        )}
      </div>

      <div className={styles.cardBody}>
        {loading && teams?.length === 0 ? (
          <div className={styles.emptyState}>
            <div className={styles.emptyText}>Loading teams…</div>
          </div>
        ) : teams?.length > 0 ? (
          <div className={styles.teamsGrid}>
            {teams?.map((team) => (
              <TeamCard
                key={team?._id}
                team={team}
                canWrite={canWrite}
                onEdit={onEditTeam}
                onDelete={onDeleteTeam}
              />
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <IconHierarchyOff size={26} />
            </div>
            <div className={styles.emptyTitle}>No teams yet</div>
            <div className={styles.emptyText}>
              Create your first team to group users by function or project.
            </div>
            {canWrite && (
              <Button
                variant="primary"
                leftIcon={<IconPlus size={16} />}
                onClick={onAddTeam}
                style={{ marginTop: 8 }}
              >
                Create a team
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
